import { motion } from 'framer-motion';
import React from 'react';
import imgUnnamed21 from "../assets/images/ladies.png";
import imgBroadwayBingoNewOriginalSalinasLogo1 from "../assets/images/BBLogostars.png";

export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-white via-gray-50 to-gray-100 overflow-hidden min-h-[60vh] flex items-center">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_#de0016_1px,_transparent_1px)] bg-[size:50px_50px]" />
      </div>
      
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0">
        <div className="" />
        <img 
          alt="Bingo players background" 
          className="w-full h-full object-cover opacity-75"
          src={imgUnnamed21} 
        />
      </div>
      
      {/* Logo with Animation */}
      <div className="relative container mx-auto px-4 py-16 md:py-24 flex justify-center items-center z-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative"
        >
          {/* Glow effect */}
          <div className="absolute inset-0 blur-3xl bg-[#de0016]/20 scale-110" />
          
          <motion.img 
            alt="Broadway Bingo Original Salinas Logo" 
            className="relative w-full max-w-[500px] md:max-w-[700px] lg:max-w-[844px] h-auto drop-shadow-2xl"
            src={imgBroadwayBingoNewOriginalSalinasLogo1}
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300 }}
          />
        </motion.div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
}
